export const countMessagesReceivedByHourOfWeek = {
  analysisType: 'count',
  eventCollection: 'message.received',
  groupBy: 'time.hour_of_week',
  key: 'countMessagesReceivedByHourOfWeek',
}
